import React from 'react';

/**
 * Card Component
 * Reusable card container with optional hover effects
 */
const Card = ({
  children,
  hover = false,
  padding = 'default',
  className = '',
  onClick,
  ...props
}) => {
  // Base classes
  const baseClasses = hover ? 'card-hover' : 'card';

  // Padding classes
  const paddingClasses = {
    none: '',
    sm: 'p-4',
    default: 'p-6',
    lg: 'p-8',
  };

  // Clickable classes
  const clickableClasses = onClick ? 'cursor-pointer' : '';

  // Combine all classes
  const cardClasses = `
    ${baseClasses}
    ${paddingClasses[padding] || paddingClasses.default}
    ${clickableClasses}
    ${className}
  `.trim().replace(/\s+/g, ' ');

  return (
    <div className={cardClasses} onClick={onClick} {...props}>
      {children}
    </div>
  );
};

/**
 * Card Header
 */
export const CardHeader = ({ children, className = '' }) => {
  return (
    <div className={`border-b border-bukawa-gray-200 pb-4 mb-4 ${className}`}>
      {children}
    </div>
  );
};

/**
 * Card Body
 */
export const CardBody = ({ children, className = '' }) => {
  return <div className={className}>{children}</div>;
};

/**
 * Card Footer
 */
export const CardFooter = ({ children, className = '' }) => {
  return (
    <div className={`border-t border-bukawa-gray-200 pt-4 mt-4 ${className}`}>
      {children}
    </div>
  );
};

/**
 * Card Title
 */
export const CardTitle = ({ children, className = '' }) => {
  return (
    <h3 className={`text-xl font-semibold text-bukawa-gray-900 ${className}`}>
      {children}
    </h3>
  );
};

/**
 * Card Description
 */
export const CardDescription = ({ children, className = '' }) => {
  return (
    <p className={`text-bukawa-gray-600 mt-2 ${className}`}>
      {children}
    </p>
  );
};

export default Card;